import { render, staticRenderFns } from "./BirthdateQuestion.vue?vue&type=template&id=3021a3c0&"
import script from "./BirthdateQuestion.vue?vue&type=script&lang=js&"
export * from "./BirthdateQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports